import React from "react";
import DataTable from "../DataTable/DataTable";

const VoucherBuilderPurchasePaymentDataTable = (props) => {
  return (
    <div>
      <DataTable
        endpoint={props.purchase_payment_path ? props.purchase_payment_path : null}
        newRecord={props.new_record}
        no_data_text={I18n.t('none')}
        currency_unit={I18n.t('number.currency.format.unit')}
        delimiter={I18n.t('number.currency.format.delimiter')}
        separator={I18n.t('number.currency.format.separator')}
        date_format={props.date_format}
        time_format={props.time_format} 
        />
    </div>
  );
};

export default VoucherBuilderPurchasePaymentDataTable;